import React from 'react';
import { PageHeader } from '../../components/Shared';
import ScheduleCalendar from '../../components/ScheduleCalendar';
import { useAuth } from '../../context/AuthContext';

const MySchedule = () => {
  const { user } = useAuth();
  return (
    <div className="p-4 sm:p-6 lg:p-8 space-y-6" data-testid="my-schedule-page">
      <PageHeader
        title="My Schedule"
        description="Your assigned shifts and SLA windows for upcoming work orders."
      />
      <ScheduleCalendar role="employee" currentUserId={user?.id || ''} />
    </div>
  );
};

export default MySchedule;
